
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tiktok-videos-analytics",
      function () {
        return require("private-next-pages/tiktok-videos-analytics/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tiktok-videos-analytics"])
      });
    }
  